/**
 * Created by Akihiro-Kato on 2017/01/25.
 */
const K_WIDTH = 26;
const K_HEIGHT = 37;

const markerStyle = {
  // initially any map object has left top corner at lat lng coordinates
  // it's on you to set object origin to 0,0 coordinates
  position: 'absolute',
  width: K_WIDTH,
  height: K_HEIGHT,
  left: -K_WIDTH / 2,
  top: -K_HEIGHT / 2,

  background: 'url(/images/pin.png)',
  backgroundSize: 'contain'
};

export {markerStyle};



// WEBPACK FOOTER //
// ./src/js/settings/_markerStyle.js